// angular
//   .module('HeroPRO')
//   .factory('AdvancedRegistrationFactory', advancedRegistrationFactory);

import _ from 'lodash';

/* @ngInject */
export default function AdvancedRegistrationFactory($q, $http, HPConfig) {
    let _personalInfo = {};
    let _personIdentityId = null;
    let _contractorUserId = null;
    let _idNumber = null;
    let _questions = [];
    const _pages = {
        personalInfo: {
            visible: false,
        },
        tryAgain: {
            visible: false,
        },
        questions: {
            visible: false,
        },
        emailUs: {
            visible: false,
        },
        uploadId: {
            visible: false,
        },
        success: {
            visible: false,
        },
        banned: {
            visible: false,
        },
    };

    return {
        getPages,
        setVisiblePages,
        getStates,
        attempAutoIDV,
        completeAdvancedRegistration,
        getPersonalInfo,
        setPersonalInfo,
        getPersonIdentityId,
        setPersonIdentityId,
        getContractorUserId,
        setContractorUserId,
        getIdNumber,
        setIdNumber,
        getQuestions,
        setQuestions,
        commitIDUpload,
        completeAdvancedRegActionItem,
    };

    function getPages() {
        return _pages;
    }

    // visiblePages: array of strings, names of pages
    function setVisiblePages(visiblePages) {
    // Sets visible=false for all pages except for those passed in
        _.each(_pages, (page, pageKey) => {
            const pageFound = _.find(visiblePages, visiblePage => pageKey === visiblePage);
            page.visible = (pageFound !== undefined);
        });
    }

    function attempAutoIDV(params) {
        return $http.post(`${HPConfig.heroProApi}identity/questions`, params).then(response => response);
    }

    function completeAdvancedRegistration(params) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/CompleteAdvancedRegistration`, params).then(response => response);
    }

    function commitIDUpload(params) {
        return $http.post(`${HPConfig.heroProApi}DocumentManagement/CommitPhotoUploadContractorUser`, params).then(response => response);
    }

    function getPersonalInfo() {
        return _personalInfo;
    }

    function setPersonalInfo(newPersonalInfo) {
        _personalInfo = newPersonalInfo;
    }

    function getPersonIdentityId() {
        return _personIdentityId;
    }

    function setPersonIdentityId(newPersonIdentityId) {
        _personIdentityId = newPersonIdentityId;
    }

    function getContractorUserId() {
        return _contractorUserId;
    }

    function setContractorUserId(newContractorUserId) {
        _contractorUserId = newContractorUserId;
    }

    function getIdNumber() {
        return _idNumber;
    }

    function setIdNumber(newIdNumber) {
        _idNumber = newIdNumber;
    }

    function getQuestions() {
        return _questions;
    }

    function setQuestions(newQuestions) {
        _questions = newQuestions;
    }

    function completeAdvancedRegActionItem(params) {
        return $http.post(`${HPConfig.heroProApi}ActionItem/CompleteContractorUserActionItem`, params).then(response => response);
    }

    function getStates() {
        const deferred = $q.defer();
        const states = [
            { StateAbbreviation: 'AL', Name: 'Alabama' },
            { StateAbbreviation: 'AK', Name: 'Alaska' },
            { StateAbbreviation: 'AZ', Name: 'Arizona' },
            { StateAbbreviation: 'AR', Name: 'Arkansas' },
            { StateAbbreviation: 'CA', Name: 'California' },
            { StateAbbreviation: 'CO', Name: 'Colorado' },
            { StateAbbreviation: 'CT', Name: 'Connecticut' },
            { StateAbbreviation: 'DE', Name: 'Delaware' },
            { StateAbbreviation: 'DC', Name: 'District Of Columbia' },
            { StateAbbreviation: 'FL', Name: 'Florida' },
            { StateAbbreviation: 'GA', Name: 'Georgia' },
            { StateAbbreviation: 'HI', Name: 'Hawaii' },
            { StateAbbreviation: 'ID', Name: 'Idaho' },
            { StateAbbreviation: 'IL', Name: 'Illinois' },
            { StateAbbreviation: 'IN', Name: 'Indiana' },
            { StateAbbreviation: 'IA', Name: 'Iowa' },
            { StateAbbreviation: 'KS', Name: 'Kansas' },
            { StateAbbreviation: 'KY', Name: 'Kentucky' },
            { StateAbbreviation: 'LA', Name: 'Louisiana' },
            { StateAbbreviation: 'ME', Name: 'Maine' },
            { StateAbbreviation: 'MD', Name: 'Maryland' },
            { StateAbbreviation: 'MA', Name: 'Massachusetts' },
            { StateAbbreviation: 'MI', Name: 'Michigan' },
            { StateAbbreviation: 'MN', Name: 'Minnesota' },
            { StateAbbreviation: 'MS', Name: 'Mississippi' },
            { StateAbbreviation: 'MO', Name: 'Missouri' },
            { StateAbbreviation: 'MT', Name: 'Montana' },
            { StateAbbreviation: 'NE', Name: 'Nebraska' },
            { StateAbbreviation: 'NV', Name: 'Nevada' },
            { StateAbbreviation: 'NH', Name: 'New Hampshire' },
            { StateAbbreviation: 'NJ', Name: 'New Jersey' },
            { StateAbbreviation: 'NM', Name: 'New Mexico' },
            { StateAbbreviation: 'NY', Name: 'New York' },
            { StateAbbreviation: 'NC', Name: 'North Carolina' },
            { StateAbbreviation: 'ND', Name: 'North Dakota' },
            { StateAbbreviation: 'OH', Name: 'Ohio' },
            { StateAbbreviation: 'OK', Name: 'Oklahoma' },
            { StateAbbreviation: 'OR', Name: 'Oregon' },
            { StateAbbreviation: 'PA', Name: 'Pennsylvania' },
            { StateAbbreviation: 'RI', Name: 'Rhode Island' },
            { StateAbbreviation: 'SC', Name: 'South Carolina' },
            { StateAbbreviation: 'SD', Name: 'South Dakota' },
            { StateAbbreviation: 'TN', Name: 'Tennessee' },
            { StateAbbreviation: 'TX', Name: 'Texas' },
            { StateAbbreviation: 'UT', Name: 'Utah' },
            { StateAbbreviation: 'VT', Name: 'Vermont' },
            { StateAbbreviation: 'VA', Name: 'Virginia' },
            { StateAbbreviation: 'WA', Name: 'Washington' },
            { StateAbbreviation: 'WV', Name: 'West Virginia' },
            { StateAbbreviation: 'WI', Name: 'Wisconsin' },
            { StateAbbreviation: 'WY', Name: 'Wyoming' },
            { StateAbbreviation: 'AS', Name: 'American Samoa' },
            { StateAbbreviation: 'GU', Name: 'Guam' },
            { StateAbbreviation: 'PR', Name: 'Puerto Rico' },
            { StateAbbreviation: 'VI', Name: 'Virgin Islands' },
        ];

        deferred.resolve(states);
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/advancedRegistration/advancedRegistrationFactory.js